import { defineStore } from 'pinia'
import { api } from '@/app/services/api.service'

export interface EntityDocumentsState {
  company_documents: any
  business_name_documents: any
  building_society_documents: any
  documents_error: any
}

export interface DocumentFilters {
  brn: string
  page: number
  limit: number
  search?: string
}

export const useEntityDocumentsStore = defineStore('entityDocuments', {
  state: (): EntityDocumentsState => ({
    company_documents: null,
    business_name_documents: null,
    building_society_documents: null,
    documents_error: null,
  }),

  getters: {
    getCompanyDocuments: (state) => state.company_documents,
    getBusinessNameDocuments: (state) => state.business_name_documents,
    getBuildingSocietyDocuments: (state) => state.building_society_documents,
    getDocumentFetcherError: (state) => state.documents_error,
  },

  actions: {
    async fetchBusinessNameDocuments(data: DocumentFilters) {
      try {
        let path = '/business-registration/attachment/' + data.brn + '?page=' + data.page + '&per_page=' + data.limit
        if (data.search !== '') {
          path += '&search=' + data.search
        }
        const response = await api().get(path)
        this.business_name_documents = response.data
      } catch (error: any) {
        this.documents_error = error.response?.data
      }
    },

    async fetchCompanyDocuments(data: DocumentFilters) {
      try {
        let path = '/incorporation/companies/continuous-filing/get-registered-documents/' + data.brn + '?page=' + data.page + '&pageSize=' + data.limit
        if (data.search !== '') {
          path += '&search=' + data.search
        }
        const response = await api().get(path)
        this.company_documents = response.data.data
      } catch (error: any) {
        this.documents_error = error.response?.data
      }
    },

    async fetchBuildingSocietyDocuments(data: DocumentFilters) {
      try {
        let path = '/building-society/societies/get-registered-documents/' + data.brn + '?page=' + data.page + '&pageSize=' + data.limit
        if (data.search !== '') {
          path += '&search=' + data.search
        }
        const response = await api().get(path)
        this.building_society_documents = response.data
      } catch (error: any) {
        this.documents_error = error.response?.data
      }
    },
  },
})
